var url = "dd1586a4aef658448b88a03ee2ab6e9a.webp";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;